import { render } from "./NewsletterDetail.vue?vue&type=template&id=fda8482e&scoped=true"
import script from "./NewsletterDetail.vue?vue&type=script&lang=js"
export * from "./NewsletterDetail.vue?vue&type=script&lang=js"

import "./NewsletterDetail.vue?vue&type=style&index=0&id=fda8482e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fda8482e"]])

export default __exports__